import { createFileRoute } from '@tanstack/react-router';
import { MassBalanceReport } from '../../../features/reports/screens/MassBalanceReport';

/** Owned by G25. Report #3 (BUILD_SPEC.md §9.6) — THE key correctness report. */
export const Route = createFileRoute('/_authenticated/reports/mass-balance')({
  component: MassBalanceReport,
});
